import { useContext } from 'react';
import { NavContext } from 'components/privateRoute/PrivateRoute';

/**
 * CDB-494 — per-widget visibility for the v2 analytics section.
 *
 * Uses the same mechanism as the v1 dashboard: every widget is a child module under
 * Dashboardv2, toggled per role in Master > Roles > Configure Role, and read back through
 * `isAllowed(moduleKey)` — the v1 screen does exactly this with `viewTotalRevenue`,
 * `viewRealTimeEvents` and friends. Configure Role saves `role.modules`, not
 * `role.permissions`, so a module key is the only thing an admin can actually switch.
 *
 * `isAllowed` already fails open for super_admin / saas_admin / md_admin and for roles
 * with no modules configured at all, so those keep seeing everything.
 */

// Module keys, seeded by the backend as child modules of Dashboardv2.
export const V2_WIDGET_KEYS = {
  revenue: 'viewV2Revenue',
  sessions: 'viewV2Sessions',
  unitsConsumed: 'viewV2UnitsConsumed',
  activeUsers: 'viewV2ActiveUsers',
  newUsers: 'viewV2NewUsers',
  energySoldWeekly: 'viewV2EnergySoldWeekly',
  energySoldMonthly: 'viewV2EnergySoldMonthly',
  avgRevenuePerSession: 'viewV2AvgRevenuePerSession',
  avgSessionDuration: 'viewV2AvgSessionDuration',
  peakUsageHours: 'viewV2PeakUsageHours',
  topStationsRevenue: 'viewV2TopStationsRevenue',
  topStationsUtilization: 'viewV2TopStationsUtilization',
  worstStationsRevenue: 'viewV2WorstStationsRevenue',
  worstStationsUtilization: 'viewV2WorstStationsUtilization',
};

export const useWidgetPermissions = () => {
  const { isAllowed } = useContext(NavContext);
  return (widgetKey) => isAllowed(widgetKey);
};

export default useWidgetPermissions;
